const dayString = sale => `prop-${sale.day.replace(/-/gi, '')}`;
const availDay = (pkg, sale) => {
  var day = pkg.available_dates.root[dayString(sale)];
  return day == null ? null : day['prop-a'] ? day : null;
};

export default availDay;
